// src/App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/LoginForm/LoginPage";
import Dashboard from "./pages/Main/Dashboard";
import StatisticsPage from "./pages/Statistics/StatisticPage";
import PatientsPage from "./pages/Patients/PatientsPage";
import PatientDetailsPage from "./pages/PatientDetails/PatientDetailsPage";
import SettingsPage from "./pages/Settings/SettingsPage";
import AppointmentsPage from "./pages/Appointment/AppointmentPage";
import DocumentViewerPage from "./pages/DocumentViewer/DocumentViewerPage";
import EntityManagementPage from "./pages/EntityManagement/EntityManagementPage";
import authService from "./services/authService";
import AdminPage from "./pages/AdminPage/AdminPage";
import BookingPage from "./pages/BookingPage/BookingPage";
import PublicLayout from "./Components/PublicLayout";

// Component για την προστασία των Routes
const ProtectedRoute = ({ children }) => {
  const token = authService.getToken();

  // Αν δεν υπάρχει token, στείλε τον χρήστη στο login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <div className="w-full min-h-screen bg-gray-50">
        <Routes>
          {/* Public Route - Σελίδα Login */}
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/bookRv"
            element={
              <PublicLayout>
                <BookingPage />
              </PublicLayout>
            }
          />
          {/* Protected Routes - Προσβάσιμα ΜΟΝΟ με Login */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics"
            element={
              <ProtectedRoute>
                <StatisticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patients"
            element={
              <ProtectedRoute>
                <PatientsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patients/:patientId"
            element={
              <ProtectedRoute>
                <PatientDetailsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/entityManagement"
            element={
              <ProtectedRoute>
                <EntityManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/appointments"
            element={
              <ProtectedRoute>
                <AppointmentsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/documents/:documentId"
            element={
              <ProtectedRoute>
                <DocumentViewerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />

          {/* Αν ο χρήστης βάλει άγνωστο URL, στείλτον στο Dashboard (ή Login) */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
